import { apiClient } from "lib/apiClient";
import {
  IResearchReasonRequest,
  IResearchWorkItem,
} from "features/Research/types";

export const cancelResearchDemand = async (
  workItemId: string,
  demandId: string,
  request: IResearchReasonRequest
): Promise<IResearchWorkItem> => {
  const response = await apiClient.put(
    `/research/work-items/${workItemId}/demands/${demandId}/cancellation`,
    request
  );
  return response.data;
};
